import { Core } from "@faire/design-tokens";
import { useAIChatbotAccess } from "@faire/help-center-self-serve/hooks/useAIChatbotAccess";
import { getIsProduction } from "@faire/help-center-utils/serialized-data/getEnvName";
import { getIsUserImpersonating } from "@faire/help-center-utils/serialized-data/getIsUserImpersonating";
import { Information } from "@faire/web--source/slate/icons/foundation/Information";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import styled from "styled-components";

export const ChatbotBanner: React.FC = () => {
  const { hasAIChatbotAccess } = useAIChatbotAccess();
  const isProduction = getIsProduction();
  const isImpersonating = getIsUserImpersonating();
  const displayChatbotBanner =
    hasAIChatbotAccess && isImpersonating && isProduction;

  if (!displayChatbotBanner) {
    return null;
  }
  return (
    <ChatbotBannerWrapper>
      <Information />
      <Spacer width="1x" />
      <Typography>
        You are <strong>impersonating</strong> this user. Virtual Assistant
        workflows will not work when <strong>impersonating</strong>. If you are
        testing VA workflows, please login as the user.
      </Typography>
    </ChatbotBannerWrapper>
  );
};

const ChatbotBannerWrapper = styled(Row).attrs({
  justify: "center",
  align: "center",
})`
  background-color: ${Core.surface.info};
  padding: ${getSpacing("2x")};
`;
